import { useState } from "react";
import "./Calculator.scss";
import { ForwardIcon, SmartphoneIcon, SignalIcon, RouterIcon } from "../../../../shared/margincalculator/components/icons/Icon";
import Hardware from "./Hardware/Hardware";
import MobileCommunications from "./MobileCommunicatons/MobileCommunications";
import Landline from "./Landline/Landline";
import CustomerTotals from "./CustomerTotals";
import type { DeviceSelection } from "./Hardware/HardwareDetails";

type Step = "hardware" | "mobilfunk" | "festnetz";

function Calculator() {
  const [activeStep, setActiveStep] = useState<Step>("hardware");

  const handleHardwareConfirm = (selection: DeviceSelection) => {
    console.log("Hardware confirmed in Calculator:", selection);
    // Später: Logik zum Hinzufügen zum Warenkorb / Sidebar
  };

  return (
    <div className="calculator">
      {/* Step 1: Main Stepper */}
      <nav className="calculator__stepper">
        <button
          className={`calculator__step ${activeStep === "hardware" ? "calculator__step--active" : ""}`}
          onClick={() => setActiveStep("hardware")}
        >
          <SmartphoneIcon />
          <span>Step 1: Hardware</span>
        </button>
        <ForwardIcon className="calculator__step-icon" />
        <button
          className={`calculator__step ${activeStep === "mobilfunk" ? "calculator__step--active" : ""}`}
          onClick={() => setActiveStep("mobilfunk")}
        >
          <SignalIcon />
          <span>Step 2: Mobilfunk </span>
        </button>
        <ForwardIcon className="calculator__step-icon" />
        <button
          className={`calculator__step ${activeStep === "festnetz" ? "calculator__step--active" : ""}`}
          onClick={() => setActiveStep("festnetz")}
        >
          <RouterIcon />
          <span>Step 3: Festnetz</span>
        </button>
      </nav>

      {/* Grid Layout for Content and Sidebar */}
      <div className="calculator__content">
        <div className="calculator__main-view">
          {activeStep === "hardware" && (
            <Hardware
              onConfirm={handleHardwareConfirm}
              onNext={() => setActiveStep("mobilfunk")}
            />
          )}

          {activeStep === "mobilfunk" && (
            <MobileCommunications onNext={() => setActiveStep("festnetz")} />
          )}

          {activeStep === "festnetz" && <Landline />}
        </div>

        {/* Sidebar Space for Customer Totals */}
        <aside className="calculator__sidebar">
          <CustomerTotals />
        </aside>
      </div>
    </div>
  );
}

export default Calculator;
